import Vue from 'vue';

// Create an event bus instance
const eventBus = new Vue();

export default eventBus;